import { Dropdown } from 'primereact/dropdown';
import React, { useEffect, useState } from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { Calendar } from 'primereact/calendar';
import { useGetAllParentClientsQuery, //useGetManagersQuery, 
    useGetTwoUpManagersPcQuery } from '../coachingSlice';

export interface ManagerSelectionViewProps {
    employeeName: string;
    selectedManager: React.Dispatch<any>;
    selectedDate: React.Dispatch<any>;
    userParentClient: any[];
}

export const ManagerSelectionView = ({
    employeeName, selectedManager, selectedDate, userParentClient

}: ManagerSelectionViewProps) => {
    const [selectedParentClient, setSelectedParentClient] = useState(userParentClient);
    const [selectedMngr, setSelectedMngr] = useState('');
    const [managersList, setManagersList] = useState([]);
    const [selectedDt, setSelectedDt] = useState(new Date());
    const { data: allParentClientsData } = useGetAllParentClientsQuery(

    );
    const { data: managersData } = useGetTwoUpManagersPcQuery(
        {
            parentClientIds: selectedParentClient,
        },
        {
            skip: !selectedParentClient,
        }
    );
    const onParentClientChange = (e: any) => {
        setSelectedParentClient(e.value);
        setSelectedMngr('');
        if (selectedParentClient.length > 0) {
            setSelectedMngr('');
            setManagersList([]);
        }
    };
    useEffect(() => {
        if (managersData?.data.length > 0)
            setManagersList(managersData?.data);
    }, [managersData]);
    const DateOnChange = (e: any) => {
        setSelectedDt(e.value);
    };
    useEffect(() => {
        selectedDate(new Date(selectedDt));
        selectedManager(selectedMngr);
    }, [selectedDt, selectedMngr]);

    useEffect(() => {
        setSelectedParentClient(userParentClient);
    }, [userParentClient]);
    return (
        <>
            <div className="row mt-4">
                <h5>Executive Director</h5>
                <div className="col-md-6" style={{ fontSize: '17px', fontWeight: 400 }}>{employeeName}</div>
            </div>
            <div className="row mt-4">
                <div className="col-md-3">
                    <div className="content">
                        <label htmlFor="selectmonth">Month</label>
                        <Calendar
                            id="selectmonth"
                            value={selectedDt}
                            onChange={DateOnChange}
                            view="month"
                            maxDate={new Date()}
                            showIcon
                            className="custom-calendar"
                            dateFormat="MM, yy"
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="content">
                        <label htmlFor="parentClient">Parent Client</label>
                        <MultiSelect
                            id="parentClient"
                            filter
                            placeholder="Select Parent Client"
                            options={allParentClientsData?.data}
                            optionValue={'parent_client_id'}
                            optionLabel={'parent_client_name'}
                            value={selectedParentClient}
                            onChange={onParentClientChange}
                            maxSelectedLabels={3} className="custom-dropdown"
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="content">
                        <label htmlFor="select-mngr">Select Manager</label>
                        <Dropdown
                            id="select-mngr"
                            placeholder="Select Manager"
                            className="custom-dropdown "
                            options={managersList}
                            optionValue={'employee_number'}
                            optionLabel={'employee_name'}
                            value={selectedMngr}
                            onChange={(e) => {
                                setSelectedMngr(e.target.value);
                            }}
                            filter
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
